import { useState, useMemo } from 'react'
import {
  calcularPrecioMensual,
  obtenerPrecioUnitario,
  TIERS_CORREO,
  TIERS_WHATSAPP,
  TIERS_CORREO_WHATSAPP,
} from '../lib/pricing-tiers'

interface CalculatorState {
  volCorreo: number
  volWhatsapp: number
  volCorreoWhatsapp: number
  meses: number
}

export function usePricingCalculator() {
  const [state, setState] = useState<CalculatorState>({
    volCorreo: 0,
    volWhatsapp: 0,
    volCorreoWhatsapp: 0,
    meses: 1,
  })

  const setVolCorreo = (v: number) => setState((s) => ({ ...s, volCorreo: v }))
  const setVolWhatsapp = (v: number) => setState((s) => ({ ...s, volWhatsapp: v }))
  const setVolCorreoWhatsapp = (v: number) => setState((s) => ({ ...s, volCorreoWhatsapp: v }))
  const setMeses = (m: number) => setState((s) => ({ ...s, meses: m }))

  const precioMensual = useMemo(
    () => calcularPrecioMensual(state.volCorreo, state.volWhatsapp, state.volCorreoWhatsapp),
    [state.volCorreo, state.volWhatsapp, state.volCorreoWhatsapp]
  )

  const precioTotal = useMemo(
    () => Math.round(precioMensual * state.meses * 100) / 100,
    [precioMensual, state.meses]
  )

  const totalEnvios = state.volCorreo + state.volWhatsapp + state.volCorreoWhatsapp

  const serviciosActivos = useMemo(() => {
    const activos: { label: string; volumen: number; precioUnitario: number; precioBase: number; subtotal: number }[] = []
    if (state.volCorreo > 0) {
      const pu = obtenerPrecioUnitario(state.volCorreo, TIERS_CORREO)
      activos.push({ label: 'Correo', volumen: state.volCorreo, precioUnitario: pu, precioBase: TIERS_CORREO[0].precio, subtotal: Math.round(state.volCorreo * pu * 100) / 100 })
    }
    if (state.volWhatsapp > 0) {
      const pu = obtenerPrecioUnitario(state.volWhatsapp, TIERS_WHATSAPP)
      activos.push({ label: 'WhatsApp', volumen: state.volWhatsapp, precioUnitario: pu, precioBase: TIERS_WHATSAPP[0].precio, subtotal: Math.round(state.volWhatsapp * pu * 100) / 100 })
    }
    if (state.volCorreoWhatsapp > 0) {
      const pu = obtenerPrecioUnitario(state.volCorreoWhatsapp, TIERS_CORREO_WHATSAPP)
      activos.push({ label: 'Correo + WhatsApp', volumen: state.volCorreoWhatsapp, precioUnitario: pu, precioBase: TIERS_CORREO_WHATSAPP[0].precio, subtotal: Math.round(state.volCorreoWhatsapp * pu * 100) / 100 })
    }
    return activos
  }, [state.volCorreo, state.volWhatsapp, state.volCorreoWhatsapp])

  const reset = () => setState({ volCorreo: 0, volWhatsapp: 0, volCorreoWhatsapp: 0, meses: 1 })

  return {
    ...state,
    setVolCorreo,
    setVolWhatsapp,
    setVolCorreoWhatsapp,
    setMeses,
    precioMensual,
    precioTotal,
    totalEnvios,
    serviciosActivos,
    reset,
  }
}
